module.exports = __webpack_public_path__ + "static/media/dsr_accClose.528bc19a.svg";